import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { ITeudotTypeItem } from '../../../modules/API/Defaults/models/teudotTypes';

interface Props {
    types: ITeudotTypeItem[];
    value: ITeudotTypeItem | null;
    onSelect: (type: ITeudotTypeItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const TeudaTypeSelector: React.FC<Props> = ({
    types,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
        <SearchableSelect<ITeudotTypeItem>
            items={types}
            value={value}
            onSelect={onSelect}
            getKey={(type) => type.SerialID}
            getLabel={(type) => (type.TeudaDesc ?? '').trim()}
            placeholder={placeholder ?? t('selectors_teudaType_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            className={className}
            emptyLabel={t('selectors_teudaType_empty')}
        />
    );
};

export default TeudaTypeSelector;
